var _sodipodiNamedview, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsNs1: "http://sozi.baierouge.fr",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg8745",
    sodipodiDocname: "New document 22",
    viewBox: "0 0 629.07 646.04",
    inkscapeVersion: "0.47 r22583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    bordercolor: "#666666",
    inkscapePageshadow: 2,
    "inkscapeWindow-y": 24,
    pagecolor: "#ffffff",
    "inkscapeWindow-height": 504,
    "inkscapeWindow-maximized": 0,
    inkscapeZoom: 0.35,
    "inkscapeWindow-x": 0,
    showgrid: "false",
    borderopacity: 1,
    "inkscapeCurrent-layer": "layer1",
    inkscapeCx: 314.53634,
    inkscapeCy: 323.01909,
    "inkscapeWindow-width": 613,
    inkscapePageopacity: 0,
    "inkscapeDocument-units": "px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    transform: "translate(-60.464 -209.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8664",
    transform: "translate(117.37 -147.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8642",
    transform: "matrix(.98481 -.17365 .17365 .98481 -204.71 -19.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8644",
    style: {
      stroke: "#000000",
      strokeWidth: 8,
      fill: "#f9f9f9"
    },
    height: 531.34,
    width: 386.89,
    y: 467.48,
    x: 71.721
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8646",
    transform: "translate(0 15.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8648",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 273.75,
    y: 523.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8650",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 236.38,
    y: 569.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8652",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 266.68,
    y: 615.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8654",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 201.02,
    y: 661.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8656",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 269.71,
    y: 735.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8658",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 253.55,
    y: 785.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8660",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 279.81,
    y: 833.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8662",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 173.75,
    y: 883.04,
    x: 110.11
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g8620",
    transform: "matrix(.99619 .087156 -.087156 .99619 152.05 -43.178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8622",
    style: {
      stroke: "#000000",
      strokeWidth: 8,
      fill: "#f9f9f9"
    },
    height: 531.34,
    width: 386.89,
    y: 467.48,
    x: 71.721
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8624",
    transform: "translate(0 15.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8626",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 273.75,
    y: 523.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8628",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 236.38,
    y: 569.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8630",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 266.68,
    y: 615.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8632",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 201.02,
    y: 661.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8634",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 269.71,
    y: 735.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8636",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 253.55,
    y: 785.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8638",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 279.81,
    y: 833.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8640",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 173.75,
    y: 883.04,
    x: 110.11
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g8608"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8580",
    style: {
      stroke: "#000000",
      strokeWidth: 8,
      fill: "#f9f9f9"
    },
    height: 531.34,
    width: 386.89,
    y: 467.48,
    x: 71.721
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8598",
    transform: "translate(0 15.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8582",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 273.75,
    y: 523.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8584",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 236.38,
    y: 569.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8586",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 266.68,
    y: 615.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8588",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 201.02,
    y: 661.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8590",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 269.71,
    y: 735.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8592",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 253.55,
    y: 785.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8594",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 279.81,
    y: 833.04,
    x: 110.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8596",
    style: {
      fill: "#000000"
    },
    height: 29.294,
    width: 173.75,
    y: 883.04,
    x: 110.11
  }))))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", null, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("ccLicense", {
    rdfResource: "http://creativecommons.org/licenses/publicdomain/"
  }), /*#__PURE__*/React.createElement("dcPublisher", null, /*#__PURE__*/React.createElement("ccAgent", {
    rdfAbout: "http://openclipart.org/"
  }, /*#__PURE__*/React.createElement("dcTitle", null, "Openclipart"))), /*#__PURE__*/React.createElement("dcTitle", null, "office-notes-line drawing"), /*#__PURE__*/React.createElement("dcDate", null, "2010-08-06T23:32:51"), /*#__PURE__*/React.createElement("dcDescription", null), /*#__PURE__*/React.createElement("dcSource", null, "https://openclipart.org/detail/78169/office-notes-line-drawing-by-sheikh_tuhin"), /*#__PURE__*/React.createElement("dcCreator", null, /*#__PURE__*/React.createElement("ccAgent", null, /*#__PURE__*/React.createElement("dcTitle", null, "sheikh_tuhin"))), /*#__PURE__*/React.createElement("dcSubject", null, /*#__PURE__*/React.createElement("rdfBag", null, /*#__PURE__*/React.createElement("rdfLi", null, "notes"), /*#__PURE__*/React.createElement("rdfLi", null, "office"), /*#__PURE__*/React.createElement("rdfLi", null, "pages"), /*#__PURE__*/React.createElement("rdfLi", null, "papers"), /*#__PURE__*/React.createElement("rdfLi", null, "print"), /*#__PURE__*/React.createElement("rdfLi", null, "report")))), /*#__PURE__*/React.createElement("ccLicense", {
    rdfAbout: "http://creativecommons.org/licenses/publicdomain/"
  }, /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Reproduction"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Distribution"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#DerivativeWorks"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.50c249ddaac8f19e1d6be8d637a6284f.svg";
export { ForwardRef as ReactComponent };